import { toast } from '@postscript/components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'controllers/network/apiClient';
import type { FeedbackResponseItem, UnifiedFeedbackPayload } from './types';

interface SubmitResponse {
  data: FeedbackResponseItem;
  message: string;
}

const SUBMIT_PATH = '/v2/ai-components/feedback/submit';

export function useSubmitFeedback() {
  const queryClient = useQueryClient();

  return useMutation<SubmitResponse, Error, UnifiedFeedbackPayload>({
    mutationFn: ({ shopId, ...payload }) =>
      api.post<SubmitResponse>(
        shopId != null ? `${SUBMIT_PATH}?shop_id=${shopId}` : SUBMIT_PATH,
        payload,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['feedback'] });
      toast.success('Feedback submitted');
    },
  });
}
